import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { img, labelize, slugify } from './ui';

/* Product Range panel — entirely generated from website_products.category.
 * Left: category index (unlimited, scrolls). Right: live preview of the
 * hovered category. Any category an admin adds tomorrow shows up automatically. */
export default function MegaMenu({ categories = [], onNavigate }) {
  const [active, setActive] = useState(0);
  if (!categories.length) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-10 text-sm text-[#4a3d32]">
        Product categories will appear here once added from the admin panel.
      </div>
    );
  }
  const current = categories[Math.min(active, categories.length - 1)];

  return (
    <div className="max-w-6xl mx-auto px-6 py-9 grid grid-cols-[1.4fr_1fr] gap-10">
      {/* category index */}
      <div>
        <div className="text-[10.5px] uppercase tracking-[0.24em] text-[#b5622f] mb-5">
          Browse by category
        </div>
        <div className="grid grid-cols-2 gap-x-10 gap-y-1 max-h-[46vh] overflow-y-auto pr-2">
          {categories.map((cat, i) => (
            <div key={cat.name} onMouseEnter={() => setActive(i)}>
              <Link
                to={`/products?category=${encodeURIComponent(slugify(cat.name))}`}
                onClick={onNavigate}
                className={`group flex items-baseline justify-between py-2 border-b border-[#241811]/8 ${
                  i === active ? 'text-[#b5622f]' : 'text-[#241811]'
                }`}
              >
                <span className="font-display text-[17px] group-hover:text-[#b5622f] transition-colors">
                  {labelize(cat.name)}
                </span>
                <span className="text-[11px] tabular-nums text-[#4a3d32]">{cat.count}</span>
              </Link>
            </div>
          ))}
        </div>
        <Link
          to="/products"
          onClick={onNavigate}
          className="inline-flex items-center gap-2 mt-6 text-[11px] uppercase tracking-[0.16em] text-[#241811] border-b border-[#241811]/30 pb-0.5 hover:text-[#b5622f] hover:border-[#b5622f] transition-colors"
        >
          View entire collection <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>

      {/* featured preview */}
      <Link
        to={`/products?category=${encodeURIComponent(slugify(current.name))}`}
        onClick={onNavigate}
        className="group relative overflow-hidden bg-[#ece0cd]"
      >
        <img
          src={img(current.cover)}
          alt={labelize(current.name)}
          className="w-full h-full min-h-[240px] object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-[#160f0a]/85 via-[#160f0a]/10 to-transparent" />
        <div className="absolute left-0 right-0 bottom-0 p-6 text-[#f4ece0]">
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-[#d98a52] mb-1.5">Featured</div>
          <div className="font-display text-2xl">{labelize(current.name)}</div>
          <div className="text-[13px] opacity-85 mt-1">{current.count} piece{current.count !== 1 ? 's' : ''}</div>
        </div>
      </Link>
    </div>
  );
}
